// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconShareSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 36 37"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M25.52 12.217l-.88-.88a1.131 1.131 0 00-.919-.322l-3.709.412.124 1.118 3.708-.413.043.042-7.353 7.354.795.796 7.354-7.354.041.041-.412 3.71 1.119.125.412-3.71a1.122 1.122 0 00-.323-.919z" />
      <path d="M22.5 24.482a1.126 1.126 0 01-1.125 1.125h-9a1.126 1.126 0 01-1.125-1.125v-9a1.126 1.126 0 011.125-1.125h4.5v-1.125h-4.5a2.253 2.253 0 00-2.25 2.25v9a2.253 2.253 0 002.25 2.25h9a2.253 2.253 0 002.25-2.25v-4.5H22.5v4.5z" />
    </svg>
  )
}
